import { ReactNode } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import CookieConsent from '../components/CookieConsent';
import StickyContactBar from '../components/StickyContactBar';
import { ModalProvider } from '../contexts/ModalContext';

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <ModalProvider>
      <div className="min-h-screen bg-canvas pb-[var(--sticky-bar-offset,calc(4.0625rem+env(safe-area-inset-bottom)))] text-fg md:pb-0">
        <Navbar />
        <main>{children}</main>
        <Footer />
        <StickyContactBar />
        <CookieConsent />
      </div>
    </ModalProvider>
  );
};

export default MainLayout; 